import React, { useState } from 'react';
import useStyles from './styles';
import { useTheme } from '@mui/styles';
import { Strings } from '../../utils/strings';
import { Avatar } from '@mui/material';
import { icons } from '../../utils/icons';
import moment from 'moment/moment';
import { CircularProgress } from '@material-ui/core';

const FeedBackContainer = (props) => {
  const { dataList } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [openFeedback, setOpenFeedback] = useState([]);

  const handleOpenFeedback = (index) => {
    if (openFeedback.findIndex((item, i) => item === index) === -1) {
      setOpenFeedback([...openFeedback, index]);
    } else {
      setOpenFeedback(openFeedback.filter((item) => item !== index));
    }
  };

  return (
    <>
      {props.loading ? (
        <div className={classes.flexView}>
          <CircularProgress
            style={{
              color: theme.palette.background_button,
            }}
          />
        </div>
      ) : props.dataList?.length === 0 ? (
        <div className={classes.flexView}>
          <p className={classes.no_data_message}>{Strings.NO_DATA_FOUND}</p>
        </div>
      ) : (
        <>
          {dataList.map((data, index) => {
            return (
              <div className={classes.container}>
                <div
                  className={classes.feedback_header}
                  onClick={() => handleOpenFeedback(index)}
                >
                  <img
                    className={classes.toggle_arrow}
                    src={
                      openFeedback.findIndex((item) => item === index) !== -1
                        ? icons(theme).downArrow
                        : icons(theme).rightArrow
                    }
                    alt=''
                  />
                  <label htmlFor='date' className={classes.feedback_title}>
                    {data?.title && data?.title}
                  </label>
                </div>
                {openFeedback.findIndex((item) => item === index) !== -1 && (
                  <div className={classes.feedback_container}>
                    <label className={classes.text_small_light}>
                      {data?.description}
                    </label>
                  </div>
                )}
                <div className={classes.feedback_footer}>
                  <label className={classes.text_small_light}>
                    {Strings.SENT_BY + ' : '}
                    <span className={classes.text_small_dark}>
                      {data?.createdBy && data?.createdBy?.name}
                    </span>
                  </label>
                  <label
                    className={classes.text_small_light}
                    style={{ marginTop: 2 }}
                  >
                    on {moment(data?.createdAt).format('ll')} at{' '}
                    {moment(data?.createdAt).format('h:mmA')}
                  </label>
                  <div
                    className={classes.feedback_header}
                    style={{ marginTop: 5 }}
                  >
                    <label className={classes.text_small_light}>
                      {Strings.ADMIN + ' : '}
                      {data?.admin && data?.admin?.name}
                    </label>
                    <Avatar
                      src={
                        data?.admin?.profilePicture &&
                        data?.admin?.profilePicture
                      }
                      alt=''
                      style={{
                        border: 'none',
                        marginLeft: 'auto',
                        height: 32,
                        width: 32,
                      }}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </>
      )}
    </>
  );
};

export default FeedBackContainer;
